export const promptRecordsKeys = {
    all: () => ['prompt-records'],
    messageRecordsById: (id) => [...promptRecordsKeys.all(), id]
};
//# sourceMappingURL=promptRecords.keys.js.map